// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"a42f685a","472":"9b757e85","569":"24f32f46","577":"c22f55ed","678":"2d7f8816","749":"5fcd7533","861":"629465d7"}[chunkId] + ".chunk.js";
};